import React, { useState, useEffect } from "react";
import "./EditAdress.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import "../../../assets/styles/general/select.scss";
import InputMask from "react-input-mask";

import { useAuthValidation } from "../../../hooks/useAuthValidation";
import api from "../../../services/api";
import DefaultLayout from "../../components/Layouts/DefaultLayout";

const COUNTRY_OPTIONS = [
  { value: "Brasil", label: "Brasil" },
  { value: "Argentina", label: "Argentina" },
  { value: "Paraguay", label: "Paraguay" },
  { value: "Uruguay", label: "Uruguay" },
  { value: "Colombia", label: "Colombia" },
];

function EditAdress() {
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cep, setCep] = useState("");
  const { user, loading } = useAuthValidation();
  const [isClearing, setIsClearing] = useState(false);
  
  const [formUser, setFormUser] = useState({
    state: "",
    cep: "",
    city: "",
    neighborhood: "",
    address: "",
    number: "",
    complement: "",
    country: "",
  });

  // Inicializa o formulário com os dados do usuário do contexto
  useEffect(() => {
    if (!loading && user) {
      setFormUser({
        state: user.address?.state || "",
        cep: user.address?.cep || "",
        city: user.address?.city || "",
        neighborhood: user.address?.neighborhood || "",
        address: user.address?.address || "",
        number: user.address?.number || "",
        complement: user.address?.complement || "",
        country: user.address?.country || "",
      });
    }
  }, [loading, user]);

  // Enquanto estiver carregando a validação
  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  // Se não houver usuário, significa que já houve redirecionamento
  if (!user) {
    return null;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    try {
      await api.post("/user/update/address", formUser, {
        headers: { "Content-Type": "application/json" },
      });
      navigate("/perfil");
    } catch (error) {
      console.error("Erro ao atualizar endereço:", error);
      setErrors((prevErrors) => ({
        ...prevErrors,
        general: t("edit-address-update-error"),
      }));
    }
  };

  const handleCepChange = (e) => {
    const country = formUser.country;

    if (country === "Argentina") {
      setFormUser((prevData) => ({
        ...prevData,
        cep: e.target.value,
        address: "",
        neighborhood: "",
        city: "",
        state: "",
        country: "Argentina",
      }));
      return;
    }

    const raw = e.target.value.replace(/\D/g, "");
    const isBrasilFlow = country === "Brasil" || country === "";

    let cepDisplay;
    if (country === "Paraguay" || country === "Uruguay") {
      cepDisplay = raw.slice(0, 5);
    } else {
      cepDisplay = formatCep(raw.slice(0, 8));
    }

    setFormUser((prevData) => ({
      ...prevData,
      cep: cepDisplay,
      address: "",
      neighborhood: "",
      city: "",
      state: "",
      country:
      country === "Paraguay" || country === "Uruguay" || country === "Colombia" ? country : "Brasil",
    }));
    if (raw.length <= 8) {
      setCep(raw);
    }
    if (isBrasilFlow && raw.length === 8) {
      fetchEndereco(raw.slice(0, 8));
    }
  };

  const formatCep = (value) => {
    if (value.length > 5) {
      return value.replace(/^(\d{5})(\d)/, "$1-$2");
    }
    return value;
  };

  const fetchEndereco = async (cep) => {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();
      console.log(data)
      if (data.erro) {
        alert(t("common-cep-not-found"));
        setFormUser((prevData) => ({
          ...prevData,
          address: "",
          neighborhood: "",
          city: "",
          state: "",
        }));
      } else {
        setFormUser((prevData) => ({
          ...prevData,
          address: data.logradouro,
          neighborhood: data.bairro,
          city: data.localidade,
          state: data.estado,
        }));
      }
    } catch (error) {
      alert(t("common-address-fetch-error"));
    }
  };

  return (
    <DefaultLayout>
      <section className="editAdress">
        <div className="container">
          <span>{t("edit-address-title")}</span>
          <form onSubmit={handleSubmit}>
            <div className="data-step">
              <div>
                <Select
                  options={COUNTRY_OPTIONS}
                  classNamePrefix="select"
                  placeholder={t("new-account-select-country")}
                  value={COUNTRY_OPTIONS.find((opt) => opt.value === formUser.country) || null}
                  onChange={(option) => {
                    setFormUser((prev) => ({
                      ...prev,
                      country: option ? option.value : "",
                    }));
                    setErrors((prevErrors) => ({ ...prevErrors, country: null }));
                  }}
                />
                {errors.country && <p className="error">{errors.country}</p>}
              </div>
              <div>
              {formUser.country === "Argentina" ? (
                <input
                  id="cep"
                  placeholder={t("edit-address-input-2")}
                  value={formUser.cep}
                  name="cep"
                  onChange={handleCepChange}
                  type="text"
                  required
                />
              ) : (
                <InputMask
                  id="cep"
                  key={`cep-${formUser.country}-${isClearing}`}
                  placeholder={t("edit-address-input-2")}
                  value={formUser.cep}
                  name="cep"
                  onChange={handleCepChange}
                  type="text"
                  required
                  mask={
                    (!isClearing
                      ? formUser.country === "Brasil"
                        ? "99999-999"
                        : formUser.country === "Paraguay"
                        ? "99999"
                        : formUser.country === "Colombia"
                        ? "999999"
                        : formUser.country === "Uruguay"
                        ? "99999"
                        : ""
                      : "") || false
                  }
                />
              )}
              {errors.cep && <p className="error">{errors.cep}</p>}
            </div>
            <div>
              <input
                placeholder={t("edit-address-input-1")}
                value={formUser.state}
                name="state"
                onChange={handleChange}
                type="text"
                required
              />
              {errors.state && <p className="error">{errors.state}</p>}
            </div>
            <div>
              <input
                placeholder={t("edit-address-input-3")}
                value={formUser.city}
                name="city"
                onChange={handleChange}
                type="text"
                required
              />
              {errors.city && <p className="error">{errors.city}</p>}
            </div>
            <div>
              <input
                placeholder={t("edit-address-input-4")}
                value={formUser.neighborhood}
                name="neighborhood"
                onChange={handleChange}
                type="text"
                required
              />
              {errors.neighborhood && <p className="error">{errors.neighborhood}</p>}
            </div>
            <div>
              <input
                placeholder={t("edit-address-input-5")}
                value={formUser.address}
                name="address"
                onChange={handleChange}
                type="text"
                required
              />
              {errors.address && <p className="error">{errors.address}</p>}
            </div>
            <div>
              <input
                placeholder={t("edit-address-input-6")}
                value={formUser.number}
                name="number"
                onChange={handleChange}
                type="text"
                required
              />
              {errors.number && <p className="error">{errors.number}</p>}
            </div>
            <div>
              <input
                placeholder={t("edit-address-input-7")}
                value={formUser.complement}
                name="complement"
                onChange={handleChange}
                type="text"
              />
              {errors.complement && <p className="error">{errors.complement}</p>}
            </div>
            </div>
            {errors.general && (
              <p className="error edit-address-form-general">{errors.general}</p>
            )}
            <button type="submit">{t("edit-address-button")}</button>
          </form>
        </div>
      </section>
    </DefaultLayout>
  );
}

export default EditAdress;
